import { BRAND } from "constants/brand";
import { Ring } from "@uiball/loaders";
import "assets/styles/table.scss";
import { useSelector } from "react-redux";
import { useState, useRef } from "react";
import { Toast } from "primereact/toast";
import DeleteItem from "components/Ui/DeleteItem/DeleteItem";
import useVendorCategories from "hooks/useVendorCategories";
import AddCategory from "./AddCategory/AddCategory";
import EditCategory from "./EditCategory/EditCategory";
import Category from "./Category/Category";
import TableColumnsMenu from "components/Ui/TableColumnsMenu/TableColumnsMenu";
import TableHead from "components/Ui/TableHead/TableHead";
import useTableColumnsConfig from "hooks/useTableColumnsConfig";

const COLUMNS = [
    { id: "id", label: "#", width: "10px" },
    { id: "name", label: "الاسم", width: "100px" },
    { id: "order", label: "الترتيب", width: "80px" },
    { id: "actions", label: "الاعدادات", width: "50px" },
];

const VendorCategories = () => {
    const [showAddForm, setShowAddForm] = useState(false);
    const [showEditForm, setShowEditForm] = useState(false);
    const [showDelete, setShowDelete] = useState(false);
    const [selectedCategory, setSelectedCategory] = useState(null);
    const { loading, editCategory, deleteCategory } = useVendorCategories();
    const data = useSelector((state) => state.vendorCategory.categories);
    const toast = useRef(null);
    const { orderedColumns, visibleColumns, hiddenSet, toggleColumn, moveColumn, reset } =
        useTableColumnsConfig("vendor-categories", COLUMNS);

    const showMessage = (type, head, content) => {
        toast.current.show({
            severity: type,
            summary: head,
            detail: content,
            life: 3000,
        });
    };

    const toggleAddForm = () => {
        setShowAddForm((pre) => (pre = !pre));
    };

    const toggleEditForm = () => {
        setShowEditForm((pre) => (pre = !pre));
    };

    const setSelectedCategoryValue = (category) => {
        setSelectedCategory(category);
    };

    const toggleDelete = () => {
        setShowDelete((pre) => (pre = !pre));
    };

    const confirmDelete = async () => {
        try {
            const response = await deleteCategory(selectedCategory.id);
            // Assuming `response` contains information to check if the operation succeeded

            if (response) {
                showMessage("warn", "تم الحذف", "تم حذف القسم بنجاح");
                toggleDelete();
            } else {
                showMessage("error", "هناك خطأ", "حدث خطأ غير متوقع");
            }
        } catch (err) {
            console.error("Error adding vendor:", err);
            showMessage("error", "هناك خطأ", "حدث خطأ غير متوقع");
        }
    };

    return (
        <div className="items">
            <Toast style={{ direction: "rtl" }} ref={toast} position="top-left" />

            {loading ? (
                <div className="loadingSpinner">
                    <Ring size={40} lineWeight={5} speed={2} color={BRAND} />
                </div>
            ) : (
                <>
                    <div className="controls">
                        <div>
                            <button className="button" onClick={toggleAddForm}>
                                إضافه قسم
                            </button>
                        </div>
                        <div style={{ marginInlineStart: "auto" }}>
                            <TableColumnsMenu
                                orderedColumns={orderedColumns}
                                hiddenSet={hiddenSet}
                                toggleColumn={toggleColumn}
                                moveColumn={moveColumn}
                                reset={reset}
                            />
                        </div>
                    </div>
                    <div className="table-container">
                        <table>
                            <TableHead visibleColumns={visibleColumns} />
                            <tbody>
                                {data ? (
                                    data.map((category) => (
                                        <Category
                                            key={category.id}
                                            category={category}
                                            visibleColumns={visibleColumns}
                                            editCategory={editCategory}
                                            selectedCategory={selectedCategory}
                                            toggleEditForm={toggleEditForm}
                                            setSelectedCategoryValue={setSelectedCategoryValue}
                                            toggleDelete={toggleDelete}
                                        />
                                    ))
                                ) : (
                                    <h4>لا يوجد اقسام!</h4>
                                )}
                            </tbody>
                        </table>
                    </div>
                    <AddCategory
                        show={showAddForm}
                        close={toggleAddForm}
                        showMessage={showMessage}
                    />
                    <EditCategory
                        show={showEditForm}
                        close={toggleEditForm}
                        showMessage={showMessage}
                        category={selectedCategory}
                    />
                    <DeleteItem
                        show={showDelete}
                        close={toggleDelete}
                        loading={loading}
                        confirm={confirmDelete}
                    />
                </>
            )}
        </div>
    );
};
export default VendorCategories;
